import type { Reroute } from '@sveltejs/kit';
import { deLocalizeUrl } from '$lib/paraglide/runtime';

export const reroute: Reroute = (request) => {
	const delocalized = deLocalizeUrl(request.url).pathname;
	// Preserve trailing slash if original URL had one (deLocalizeUrl strips it)
	const hadTrailingSlash = request.url.pathname.endsWith('/');
	if (hadTrailingSlash && !delocalized.endsWith('/')) {
		return delocalized + '/';
	}
	return delocalized;
};